import { h, Component } from 'preact';
import { sortObjectByOrder, accessNested, joinClasses } from 'utils/utils';
import { goToPage } from 'components/core/link/link';
import { smoothScrollTo } from 'utils/smoothScroll';
// import Store from 'store/store';
// import * as actions from 'store/actions';
import Headline from 'components/templates/headline/headline.js';
import SmallText from 'components/templates/smallText/smallText.js';
import Hero from 'components/templates/hero/hero.js';
import Info from 'components/templates/info/info.js';
import Landing from 'components/templates/landing/landing.js';
import Gallery from 'components/templates/gallery/gallery.js';
import ScrollingCarousel from 'components/templates/scrollingCarousel/scrollingCarousel.js';
import Support from 'components/templates/support/support.js';
import Resources from 'components/templates/resources/resources.js';
import About from 'components/templates/about/about.js';
import Navigation from 'components/templates/navigation/navigation.js';
import s from 'components/pages/main/main.sss';

const componentsById = {
	headline: Headline,
	hero: Hero,
	info: Info,
	landing: Landing,
	smallText: SmallText,
	gallery: Gallery,
	navigation: Navigation,
	scrollingCarousel: ScrollingCarousel,
	support: Support,
	resources: Resources,
	about: About,
};

export default class Main extends Component {
	constructor(props) {
		super(props);
		this.renderSection = this.renderSection.bind(this);
		this.handleScroll = this.handleScroll.bind(this);
		this.updateHash = this.updateHash.bind(this);
		this.scrollToSection = this.scrollToSection.bind(this);
		this.sectionSwitcher = this.sectionSwitcher.bind(this);
		this.handleSectionSwitcherChange = this.handleSectionSwitcherChange.bind(this);
	}

	componentDidMount() {
		const app = document.getElementById('showtimesApp');
		if (this.props.activePage.scrollingSite) {
			document.getElementById('showtimesApp')?.addEventListener('scroll', this.handleScroll);
			// window.addEventListener('touchmove', this.handleScroll);
			let activeSection = location.hash.slice(1);
			if (activeSection) {
				activeSection = activeSection.split('/')[0];
			} else {
				activeSection = sortObjectByOrder(this.props.activePage.sections)[0].id;
			}
			this.setState({ activeSection });

			if (location.hash) {
				this.scrollToSection(location.hash);
			} else {
				smoothScrollTo(app, 0, 500, { force: true });
			}
		} else {
			smoothScrollTo(app, 0, 500, { force: true });
		}
	}

	componentWillUnmount() {
		if (this.props.activePage.scrollingSite) {
			document.getElementById('showtimesApp')?.removeEventListener('scroll', this.handleScroll);
			// window.removeEventListener('touchmove', this.handleScroll);
		}
	}

	handleScroll() {
		if (this.autoScrolling) {
			return;
		}
		let halfWindowHeight = window.innerHeight / 2;
		const watchedSections = [...document.querySelectorAll('[data-section-observed]')].map(section => {
			return { offset: section.offsetTop - halfWindowHeight, id: section.id };
		});

		const currentScroll = document.getElementById('showtimesApp').scrollTop;
		const activeSection = watchedSections.reverse().find(({ offset }) => offset <= currentScroll)?.id;

		if (activeSection && this.state.activeSection !== activeSection) {
			this.setState({ activeSection });
			this.updateHash(activeSection);
		}
	}

	updateHash(activeSection = this.state.activeSection) {
		let hash = this['$' + activeSection]?.getCurrentHash?.() || activeSection;
		if (!hash) {
			return;
		}
		if (!hash.startsWith('#')) {
			hash = '#' + hash;
		}
		if (hash !== location.hash) {
			history.replaceState('', '', hash);
		}
	}

	scrollToSection(url) {
		const offset = this.props.client.deviceSize === 'desktop' ? 100 : 50;
		const [, hash] = url.split('#');
		let [section] = hash?.split('/') || [];
		let element = this['$' + section]?.base;
		if (element) {
			this.autoScrolling = true;
			smoothScrollTo(
				document.getElementById('showtimesApp'),
				element,
				500,
				{
					relativeTo: 'middle',
					offset,
					// Interrupted early when not forcing... Is there a better way to handle that?
					force: true,
					callback: () => {
						this.autoScrolling = false;
						this.handleScroll();
					}
				}
			);
		}
	}

	renderExtraContent() {}

	handleSectionSwitcherChange(evt) {
		evt.preventDefault();
		if (evt.target.value === 'hub') {
			goToPage('hub');
		} else {
			this.scrollToSection('#' + evt.target.value);
		}
	}

	renderSection(section, client, copy) {
		const isDesktop = client.deviceSize === 'desktop';
		const active = this.state.activeSection === section.id;
		const Component = componentsById[section.id];
		if (!Component) {
			return;
		}
		return (
			<Component
				ref={ref => this['$' + section.id] = ref}
				id={section.id}
				data={section}
				isDesktop={isDesktop}
				active={active}
				copy={copy}
				scrollToSection={this.scrollToSection}
				updateHash={this.updateHash}
				key={section.id}
			/>
		);
	}

	sectionSwitcher(sections, isDesktop) {
		let options = sortObjectByOrder(sections);
		options.shift();
		const hub = accessNested(this.props, 'appData.copy.$HUB', 'Home');
		options.unshift({ name: hub, id: 'hub'});
		const regionToggleUsed = accessNested(this.props, 'appData.header.regionToggle');

		if (!isDesktop) {
			if (regionToggleUsed) {
				return (
					<div
						onClick={() => this.scrollToSection('#support')}
						class={s.supportBanner}
					>
						{sections.support.name}
					</div>
				);
			} else {
				return (
					<div class={s.selectWrapper}>
						<div class={s.selectContainer}>
							<select value={this.state.activeSection} onChange={this.handleSectionSwitcherChange} class={s.select}>
								{options.map(option => !!option.name && <option class={s.option} value={option.id}>{option.name}</option>)}
							</select>
							<div class={s.arrow} />
						</div>
					</div>
				);
			}
		} else {
			return (
				<div class={joinClasses(s.sectionSelect, regionToggleUsed && s.regionToggleUsed)}>
					{options.map(option => {
						if (!option.name) return;
						return (
							<button
								class={s.sectionBtn}
								onClick={() => (option.id && option.id !== 'hub') ? this.scrollToSection(`#${option.id}`) : goToPage('hub')}
							>
								{option.name}
							</button>
						);
					})}
				</div>
			);
		}

	}

	render({ activePage, client, appData }) {
		const { sections, sectionSwitcherActive } = activePage;
		const isDesktop = client.deviceSize === 'desktop';
		return (
			<main class={joinClasses(s.wrapper, activePage?.id)} ref={ref => this.main = ref}>
				{sectionSwitcherActive && this.sectionSwitcher(sections, isDesktop)}
				{sortObjectByOrder(sections).map(section => this.renderSection(section, client, appData.copy))}
				{this.renderExtraContent()}
			</main>
		);
	}

}
